// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"850ed6e2","250":"2a1dbf09","407":"aeefdc81","424":"0b07bb33","436":"02b25bfb","453":"f394a27d","455":"2b9dbaca","501":"46a67ab6","595":"8fe8b95d","606":"f7fe1808","691":"a1381eb5","821":"806b390f","925":"c9d44250","969":"fa88b7eb"}[chunkId] + ".chunk.js";
};